import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { CommentService } from '../../api/services/comment.service';
import { UserService } from '../../api/services/user.service';
import { AuthService } from '../../api/services/auth.service';
import { User } from '../../api/models/user-model';
import { EnhancementFeedback } from '../../api/models/enhancement-feedback';

@Component({
  selector: 'app-enhancement-feedback',
  templateUrl: './enhancement-feedback.component.html',
  styleUrls: ['./enhancement-feedback.component.scss']
})
export class EnhancementFeedbackComponent implements OnInit {

  constructor(
    private formBuilder: FormBuilder,
    private toastr: ToastrService,
    private authService: AuthService,
    private userService: UserService,
    private commentService: CommentService
  ) { }

  feedbackForm: FormGroup;

  user: User;
  feedbackRequest: EnhancementFeedback;

  fileUploading: boolean = false;
  hasFile: boolean = false;

  loading: boolean = true;

  ngOnInit() {
    this.userService.findUserById(this.authService.getUserId()).subscribe((user: User) => {
      this.user = user;
      this.loading = false;
      this.feedbackForm = this.formBuilder.group({
        'requestorUserId': [this.user['User ID'], Validators.required],
        'requestorFirstName': [this.user['First Name'], Validators.required],
        'requestorLastName': [this.user['Last Name'], Validators.required],
        'requestorEmail': [this.user['Email Address'], [Validators.required, Validators.email]],
        'efTitle': ['', Validators.required],
        'efDescription': ['', Validators.required],
        'efFileId': ['']
      });
    });
  }

  onFileUploading(status: boolean) {
    this.fileUploading = status;
  }

  onFeedbackFileUploaded(id: string) {
    this.hasFile = true;
    this.fileUploading = false;
    this.feedbackForm.controls['efFileId'].setValue(id.trim());
  }

  onSubmit() {
    this.feedbackForm.controls['efTitle'].setValue(this.feedbackForm.value['efTitle'].trim());
    this.feedbackForm.controls['efTitle'].updateValueAndValidity();
    this.feedbackForm.controls['efDescription'].setValue(this.feedbackForm.value['efDescription'].trim());
    this.feedbackForm.controls['efDescription'].updateValueAndValidity();
    if (this.feedbackForm.valid) {
      this.feedbackRequest = this.feedbackForm.value;
      this.commentService.submitEnhancementFeedback(this.feedbackRequest).subscribe(() => {
        this.hasFile = false;
        this.feedbackForm.controls['efFileId'].setValue('');
        this.feedbackForm.controls['efTitle'].setValue('');
        this.feedbackForm.controls['efTitle'].markAsPristine();
        this.feedbackForm.controls['efDescription'].setValue('');
        this.feedbackForm.controls['efDescription'].markAsPristine();
        this.toastr.success('Feedback submitted successfully', 'Succcess!', {
          timeOut: 2000,
          positionClass: 'toast-bottom-right'
        });
      }, error => {
        this.toastr.error(error, 'Error while submitting feedback', {
          timeOut: 2000,
          positionClass: 'toast-bottom-right'
        });
      });
    }
  }

}



// WEBPACK FOOTER //
// /codebuild/output/src3408204168/src/bitbucket.org/tesscotds/webclient/src/app/enhancement-feedback/enhancement-feedback.component.ts